<div id="functionbarcontainer">
  <div class="navbar navbar-expand navbar-light bg-light p-0" id="functionbar">
    <ng-content></ng-content>
  </div>
</div>
